import {useTranslation} from '@aboutyou/i18n';
import {lazy} from '@aboutyou/lazy-imports';
import {useImprintRoute} from '@aboutyou/router';
import {useTrackNewsletter} from '@aboutyou/tracking';
import {
  COLORS,
  Divider,
  FONT_SIZES,
  Heading32,
  TransparentLogo,
} from '@aboutyou/ui-components';
import React, {useState} from 'react';
import styled from 'styled-components';
import {BackgroundImageOverlay} from './BackgroundImageOverLay/BackgroundImageOverlay';
import {CountryLaunchCountDown} from './CountryLaunchCountDown/CountryLaunchCountDown';
import {CountryLaunchNewsLetter} from './CountryLaunchNewsLetter';
interface NewsletterSubscriptionData {
  email: string;
  gender: 'male' | 'female';
}

const SubscribeToNewsletter = lazy(() =>
  import(
    '../../backend-services/Footer/FooterStatic/SubscribeToNewsletter'
  ).then(mod => ({
    default: mod.SubscribeToNewsletter,
  })),
);

const LaunchTeaserPage = ({endDate}: {endDate: Date}) => {
  const {t} = useTranslation();
  const [subscribeData, setSubscribeData] = useState<
    NewsletterSubscriptionData | undefined
  >(undefined);
  const imprint = useImprintRoute();
  const trackNewsLetter = useTrackNewsletter();
  const onNewsletterSubscribe = (data: NewsletterSubscriptionData) => {
    setSubscribeData(data);
    trackNewsLetter('subscribed', data.email);
  };

  return (
    <BackgroundImageOverlay
      backgroundImage={
        'http://cdn.aboutstatic.com/file/9d234a5c99f2c3baec181548e848d31b.jpg?quality=90'
      }
    >
      <PageContainer>
        <Wrapper>
          <HeaderSection>
            <StyledHeading>{t('WHO THE F*** IS')}</StyledHeading>
            <LogoWrapper>
              <TransparentLogo />
            </LogoWrapper>
          </HeaderSection>
        </Wrapper>
        <Divider />
        <CountryLaunchCountDown onCountDownEnd={() => {}} endDate={endDate} />
        <CountryLaunchNewsLetter
          onNewsletterSubscribe={onNewsletterSubscribe}
        />
        {subscribeData && (
          <SubscribeToNewsletter
            email={subscribeData.email}
            gender={subscribeData.gender}
            resetForm={() => setSubscribeData(undefined)}
          />
        )}
        <ImprintLink target="_blank" href={imprint}>
          {t('imprint')}
        </ImprintLink>
      </PageContainer>
    </BackgroundImageOverlay>
  );
};

const LogoWrapper = styled.div`
  > div {
    height: 36px;
    width: 185px;
  }
`;

const PageContainer = styled.div`
  max-width: 620px;
`;

const ImprintLink = styled.a`
  font-size: ${FONT_SIZES.px14};
  line-height: 1.54;
  color: ${COLORS.White};
  text-decoration: none;
`;

const Wrapper = styled.div`
  max-width: 420px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledHeading = styled(Heading32)`
  color: ${COLORS.White} !important;
  margin-bottom: 14px;
`;

const HeaderSection = styled.section`
  display: flex;
  flex-direction: column;
`;

export {LaunchTeaserPage};
